export default __webpack_public_path__ + "static/media/music.6fd626a8.svg";